<template>
    <modal :show="show" class="white-content" @update:show="$emit('update:show', $event)">
      <h3 class="card-title">{{ $t('tools.updateReservation') }}</h3>
      <div class="row">
        <label class="col-md-12 col-form-label">{{ $t('tools.totalCount') }} *</label>
        <div class="col-8 pe-0">
          <material-input
            id="units"
            v-model:value="localUnits"
            :placeholder="`${$t('tools.totalCount')} ${toolPriceTypeLabel}`"
          />
        </div>
        <div class="col-4 ps-0">
          <div class="unit-type-label">{{ toolPriceTypeLabel }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm d-flex justify-content-end">
          <material-button type="standard" fill @click="$emit('submit')">{{ $t('common.submit') }}</material-button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import Modal from './Modal.vue';
  import MaterialInput from '../MaterialInput.vue';
  import MaterialButton from '../MaterialButton.vue';
  
  export default {
    components: { Modal, MaterialInput, MaterialButton },
    props: {
      show: { type: Boolean, required: true },
      units: { type: [Number, null], required: true },
      toolPriceTypeLabel: { type: String, required: true }
    },
    emits: ['update:show', 'update:units', 'submit'],
    data() {
      return {
        localUnits: this.units
      };
    },
    watch: {
      show(newVal) {
        if (newVal) {
          this.localUnits = this.units;
        }
      },
      localUnits(newVal) { this.$emit('update:units', newVal); }
    }
  };
  </script>

  <style scoped>
  .unit-type-label {
    background-color: #e9ecef;
    border: 1px solid #d2d6da;
    border-radius: 0.375rem;
    padding: 0.625rem 0.75rem;
    color: #495057;
    font-size: 0.875rem;
    height: 100%;
    display: flex;
    align-items: center;
  }
  </style>